import { ReactNode } from 'react';

interface IErrorWithMessage {
  message: string;
}
export function isMessage(error: unknown): error is IErrorWithMessage {
  return !!(typeof error === 'object' && error && 'message' in error);
}
export function processCommand(command: string) {
  return Commands[command]();
}
const Commands = {
  PREVENT_RENDERING: () => null,
} as Record<string, () => ReactNode>;

export default Commands;
